
import { Options, Vue } from 'vue-class-component'
import { FadeInOut } from 'vue3-transitions'

@Options({
  components: {
    FadeInOut
  }
})
export default class Performances extends Vue {
  public fade = false
}
